import { Directive, Injectable } from '@angular/core';
import { ApiService, IApiOption } from '@red/api';
import { Mixin } from 'ts-mixer';
import { IQuerySearch } from '@shared/data-access/interfaces';
import { Observable, map } from 'rxjs';
import { PaginationAdapter } from '@red/data-access';
import { ReportCard } from '@shared/components/report-manager';
import { ExceljsApiService, ExceljsCardCollection } from './exceljs-report-api.service';
import { MetabaseApiService, MetabaseCardCollection } from '@cms/apis';

@Directive()
abstract class AgentReportMetabaseApiService extends MetabaseApiService {
  collection: MetabaseCardCollection = 'agent_reports';
}
@Directive()
abstract class ReportExceljsApiService extends ExceljsApiService {
  collectionEndpoint = ExceljsCardCollection.AgentPortalReport;
}
@Directive()
abstract class ReportCardApiService {
  static REPORT_CARD_POINT = 'hrm/hr/reports/portal';
  constructor(protected apiService: ApiService) {}

  findReportCards(query: IQuerySearch = {}, option?: IApiOption): Observable<PaginationAdapter<ReportCard>> {
    return this.apiService.get(ReportCardApiService.REPORT_CARD_POINT, query, option).pipe(map(data => new PaginationAdapter(ReportCard, data)));
  }
}

@Injectable({
  providedIn: 'root',
})
export class ReportApiService extends Mixin(ReportCardApiService, ReportExceljsApiService, AgentReportMetabaseApiService) {}
